import { FLAGS, useFeatureIsOn } from '@komi-app/flags-sdk'

export const MAINTENANCE_TOAST_TEXT =
  'Komi is undergoing scheduled maintenance. Some features may be temporarily unavailable. Fan-facing pages are not affected.'

/**
 * True while services are taking consumer traffic only: saving, publishing and
 * the CRM are off, and a persistent maintenance toast is shown. Fan-facing
 * pages keep working.
 */
export const useMaintenance = (): boolean =>
  useFeatureIsOn(FLAGS.CONSUMER_TRAFFIC_ONLY)

export default useMaintenance
